export default "__VITE_ASSET__Cy131$tu__"